var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DetailCta"},[_c('BaseButton',{attrs:{"block":"","theme":"orange","href":_vm.computedPrimaryCta.href(_vm.app)},on:{"click":function($event){_vm.trackCta(_vm.computedPrimaryCta.text(_vm.app))}}},[_vm._v(" "+_vm._s(_vm.computedPrimaryCta.text(_vm.app))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }